'use client';

import {
  ClientTimelineProps,
  ClientTimeline as ClientTimelineComponent,
} from './ClientTimeline';

const ClientTimeline = (props: ClientTimelineProps) => {
  return <ClientTimelineComponent {...props} />;
};

export { ClientTimeline };
